import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

import { faEyeSlash, faGlobe, faSatelliteDish, faCircle as faCircleFull, faEarthAmerica } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';

import MarketingChannel from './property_edit_form/marketing_channel';
import HideInternallyCheckbox from './property_edit_form/hide_internally_checkbox';

const STATUSES_FOR_STATES = {
  '1': ['none', 'plugin', 'syndication'],
  '4': ['none']
};

export default function LeaseMarketingVisibility({
  hideInternally,
  hideSyndication,
  initialPluginShowInSearch,
  showHideInternallyForStatuses,
  statusInputName,
  syndication,
  syndicationDisconnectMessage,
  onHideInternallyChange,
  onSyndicationChange
}) {
  function getLeaseStatus(statusInputName) {
    return document.querySelector(`input[name="${statusInputName}"]:checked`).value;
  }

  const [pluginShowInSearch, setPluginShowInSearch] = useState(initialPluginShowInSearch);
  const [leaseStatus, setLeaseStatus] = useState(getLeaseStatus(statusInputName));

  useEffect(() => {
    const statusChangeHandler = (e) => {
      setLeaseStatus(e.target.value);
    };

    document.querySelectorAll(`input[name="${statusInputName}"]`).forEach((input) => {
      input.addEventListener('change', statusChangeHandler);
    });
    return () => {
      document.querySelectorAll(`input[name="${statusInputName}"]`).forEach((input) => {
        input.removeEventListener('change', statusChangeHandler);
      });
    };
  }, [statusInputName]);

  const effectiveSyndicationValue = STATUSES_FOR_STATES[leaseStatus].includes('syndication') && syndication;
  const effectivePluginValue = STATUSES_FOR_STATES[leaseStatus].includes('plugin') && pluginShowInSearch;
  const effectiveNoneValue = !effectivePluginValue && !effectiveSyndicationValue;

  const setSyndication = (value) => {
    onSyndicationChange(value);
  };

  const disableAll = () => {
    onSyndicationChange(false);
    setPluginShowInSearch(false);
  };

  return (
    <div>
      <div className="mb-5" name="root-component">
        <div className="mb-3 fw-semibold">Select the automated marketing channels to enable:</div>

        <MarketingChannel
          disabled={false}
          icon={faEyeSlash}
          name="none"
          selected={effectiveNoneValue}
          signalIcon={faCircle}
          signalText="Fully Private"
          subtitle="I want to market directly to my own contacts (network) or nowhere at this time."
          title="None"
          onToggle={disableAll}
        />

        <MarketingChannel
          disabled={!STATUSES_FOR_STATES[leaseStatus].includes('plugin')}
          icon={faGlobe}
          name="plugin"
          selected={effectivePluginValue}
          signalIcon={faCircleFull}
          signalText="Public"
          subtitle="I want to increase exposure and market on my company's website using the Buildout plugin."
          title="My Brokerage Website"
          onToggle={() => setPluginShowInSearch(!effectivePluginValue)}
        />

        {!hideSyndication && (
          <div>
            <MarketingChannel
              disabled={!STATUSES_FOR_STATES[leaseStatus].includes('syndication')}
              icon={faSatelliteDish}
              name="syndication"
              selected={effectiveSyndicationValue}
              signalIcon={faEarthAmerica}
              signalText="Fully Public"
              subtitle="I want to maximize exposure to all parties via Buildout's available lease listing sites."
              title="Buildout Syndication Network"
              onToggle={() => setSyndication(!effectiveSyndicationValue)}
            />

            {syndicationDisconnectMessage && (
              <p className="form-text strong" name="syndicationDisconnectMessage">
                {Parser(syndicationDisconnectMessage)}
              </p>
            )}
          </div>
        )}

        <input
          name="property[lease_plugin_listing_attributes][show_in_search]"
          type="hidden"
          value={pluginShowInSearch ? '1' : '0'}
        />
      </div>

      {showHideInternallyForStatuses.includes(parseInt(leaseStatus)) && (
        <div className="mb-4">
          <HideInternallyCheckbox checked={hideInternally} onChange={onHideInternallyChange} />
        </div>
      )}
    </div>
  );
}

LeaseMarketingVisibility.propTypes = {
  hideInternally: PropTypes.bool,
  hideSyndication: PropTypes.bool.isRequired,
  initialPluginShowInSearch: PropTypes.bool.isRequired,
  showHideInternallyForStatuses: PropTypes.arrayOf(PropTypes.number).isRequired,
  statusInputName: PropTypes.string.isRequired,
  syndication: PropTypes.bool.isRequired,
  syndicationDisconnectMessage: PropTypes.string,
  onHideInternallyChange: PropTypes.func.isRequired,
  onSyndicationChange: PropTypes.func.isRequired
};
